<template>
  <div class="h-full pmc-wrapper">
    <div class="pmc-right">
      <h1 class="flex mb-16">
        <div class="did-icon-wrapper">
          <DidIcon />
        </div>
        Login&nbsp;<span>DecastID</span>
      </h1>
      <!-- <button class="login-btn login-did-btn" @click="handleDidsLogin">
        <div class="did-icon-wrapper-btn">
          <DidIcon />
        </div> Login with a&nbsp;<span>DecastID</span>
      </button> -->
      <button class="login-btn login-did-btn" @click="setActiveModal('chooseVerifierModal')">
        <div class="did-icon-wrapper-btn">
          <DidIcon />
        </div> Login with a&nbsp;<span>DecastID</span>
      </button>
      <p class="did-info-label my-2" @click="navigateToWhatIsDid">What is a DecastID?</p>

      <div class="flex items-center gap-2 text-gray-400 font-mono text-sm my-8">
        <div class="sep-line flex-grow h-px"></div>
        <div class="sep-line-label">OR</div>
        <div class="sep-line flex-grow h-px"></div>
      </div>

      <button class="login-btn connect-wallet-btn" @click="setActiveModal('walletLoginModal')">
        Connect with Wallet
        <span class="login-btn-ph">WEB 3</span>
      </button>
      <button class="login-btn connect-social-btn" @click="setActiveModal('socialLoginModal')">
        Connect with Social
        <span class="login-btn-ph">WEB 2</span>
      </button>

      <div class="bottom-liner">
        <p>Don’t have an identity? <span>Create New Identity</span> or <span>Use Existing Identity</span></p>
      </div>
    </div>
    <ChooseVerifierModal v-if="activeModal === 'chooseVerifierModal'" :closeModal="() => setActiveModal('')" />
    <SocialLoginModal v-if="activeModal === 'socialLoginModal'" :closeModal="() => setActiveModal('')" />
    <WalletLoginModal v-if="activeModal === 'walletLoginModal'" :closeModal="() => setActiveModal('')" />
  </div>
</template>

<script>
// import { ref } from 'vue'
import EyeHide from "@/decast/icons/EyeHide.vue";
import EyeVisible from "@/decast/icons/EyeVisible.vue";
import GoogleLogin from '@/decast/components/v2auth/social-logins/GoogleLogin.vue'
import MetamaskLogin from "@/decast/components/v2auth/social-logins/MetamaskLogin.vue";
import DidsLogin from "@/decast/components/v2auth/social-logins/DidsLogin.vue";
import DidIcon from "../../icons/DidIcon.vue";
import ChooseVerifierModal from "../v2authModal/ChooseVerifierModal.vue";
import SocialLoginModal from "../v2authModal/SocialLoginModal.vue";
import WalletLoginModal from "../v2authModal/WalletLoginModal.vue";

export default {
  data() {
    return {
      email: '',
      password: '',
      formLevel: 1,
      emailError: '',
      passwordError: '',
      checkbox_remember_me: false,
      isPasswordVisible: false,
      activeModal: '',  //socialLoginModal, walletLoginModal

      //login-with-did-data
      nonce: '',
      isLoading: false,
      errorMessage: '',
      selectedDid: '',
    };
  },
  components: {
    EyeHide,
    EyeVisible,
    GoogleLogin,
    MetamaskLogin,
    DidsLogin,
    DidIcon,
    ChooseVerifierModal,
    SocialLoginModal,
    WalletLoginModal,
  },
  mounted() {
    document.getElementById('loading-bg-transparent').style.display = 'none';
  },
  computed: {
    passwordInputType() {
      return this.isPasswordVisible ? 'text' : 'password';
    },
  },
  methods: {
    setActiveModal(modalName) {
      this.activeModal = modalName;
    },
    updateFormLevel(formLevel) {
      this.formLevel = formLevel;
    },
    togglePasswordVisibility() {
      this.isPasswordVisible = !this.isPasswordVisible;
    },
    navigateToPassword() {
      this.$router.push('/resetPassword');
    },
    navigateToSignUp() {
      this.$router.push('/v2signup');
    },
    navigateToWhatIsDid() {
      this.$router.push('/what-is-did');
    },
    handleSubmit() {
      if (!this.email) {
        this.emailError = 'Email is required.'
        return
      }
      if (!this.password) {
        this.passwordError = 'Password is required.'
        return
      }
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      if (!emailRegex.test(this.email)) {
        this.emailError = 'Enter a valid email address.'
        return
      }
      this.emailError = '';
      this.passwordError = '';
      this.loginWithJWT();
    },
    handleSendMagicLink() {
      document.getElementById('loading-bg-transparent-title').innerText = '📩 Sending magic link to your email';
      document.getElementById('loading-bg-transparent').style.display = 'flex';
      const payload = {
        email: this.email,
      };
      this.$store
        .dispatch('auth/v2sendMagicLink', payload)
        .then((response) => {
          if (response?.status === 204) {
            this.$vs.notify({
              title: 'Successful',
              text: 'Magic link has been sent to your email address',
              iconPack: 'feather',
              icon: 'icon-check-circle',
              color: 'success',
            });
            this.updateFormLevel(4);
          }
        })
        .catch((error) => {
          // Safely extract the specific error message
          const errorResponse = error.response?.data;
          let message = "An error occurred.";
          if (errorResponse?.errors?.email) {
            message = "Account does not exist!";
          } else if (errorResponse?.errors?.password) {
            message = "Incorrect password, Please try again!";
          } else if (typeof errorResponse?.errors === 'string') {
            message = errorResponse.errors;
          }
          this.$vs.notify({
            title: 'Failed to send magic link',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger',
          });
        }).finally(() => {
          document.getElementById('loading-bg-transparent').style.display = 'none';
        });
    },
    sendForgetPasswordLink() {
      document.getElementById('loading-bg-transparent-title').innerText = '📩 Sending reset password link to email';
      document.getElementById('loading-bg-transparent').style.display = 'flex';
      const payload = {
        email: this.email,
      };
      this.$store
        .dispatch('auth/v2sendForgetPasswordLink', payload)
        .then((response) => {
          if (response?.status === 204) {
            this.$vs.notify({
              title: 'Reset link send',
              text: 'Email has been sent to reset your password',
              iconPack: 'feather',
              icon: 'icon-check-circle',
              color: 'success',
            });
            this.updateFormLevel(3);
          }
        })
        .catch((error) => {
          // Safely extract the specific error message
          const errorResponse = error.response?.data;
          let message = "An error occurred.";
          if (errorResponse?.errors?.email) {
            message = "Account does not exist!";
          } else if (errorResponse?.errors?.password) {
            message = "Incorrect password, Please try again!";
          } else if (typeof errorResponse?.errors === 'string') {
            message = errorResponse.errors;
          }
          this.$vs.notify({
            title: 'Failed to send reset link',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger',
          });
        }).finally(() => {
          document.getElementById('loading-bg-transparent').style.display = 'none';
        });
    },
    loginWithJWT() {
      document.getElementById('loading-bg-transparent-title').innerText = '👨‍💻Logging to decast';
      document.getElementById('loading-bg-transparent').style.display = 'flex';
      const payload = {
        checkbox_remember_me: this.checkbox_remember_me,
        userDetails: {
          email: this.email,
          password: this.password,
        },
      };
      this.$store
        .dispatch('auth/v2loginUser', payload)
        .then((response) => {
          const isTwoFactorAuthEnabled = response.data?.twoFactorAuthentication;
          if (isTwoFactorAuthEnabled) {
            //ask for 2fa
            const twoFactorToken = response.data?.token;
            this.$router.push({ name: 'TwoFactor', query: { tempToken: twoFactorToken } });
          } else {
            this.$store.commit('auth/SET_LOGGEDIN', true);
            this.$acl.change('user');
            this.$vs.notify({
              title: 'Login Successful',
              text: 'Redirecting to dashboard!',
              iconPack: 'feather',
              icon: 'icon-check-circle',
              color: 'success',
            });
            this.$router.push('/dashboard/rooms');
          }
        })
        .catch((error) => {
          // Safely extract the specific error message
          const errorResponse = error.response?.data;
          let message = "An error occurred.";
          if (errorResponse?.errors?.email) {
            message = "Account does not exist!";
          } else if (errorResponse?.errors?.password) {
            message = "Incorrect password, Please try again!";
          } else if (typeof errorResponse?.errors === 'string') {
            message = errorResponse.errors;
          }
          this.$vs.notify({
            title: 'Login Failed',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger',
          });
        }).finally(() => {
          document.getElementById('loading-bg-transparent').style.display = 'none';
        });
    },
  }
}
</script>

<style scoped>
*:not(i) {
  /* font-family: 'Karla', sans-serif !important; */
  font-family: 'Rethink Sans' !important;
}

button:disabled {
  opacity: 0.5;
  cursor: not-allowed !important;
}

.login-btn {
  font-size: 14px;
  border-radius: 10px;
  color: #FFFFFF;
  padding: 0rem 0.85rem;
  width: 100%;
  height: 46px !important;
  outline: none;
  border: 1px solid #FFFFFF40;
  cursor: pointer;
  transition: transform 0.05s ease-in-out;
  position: relative;
  background-color: #15161F;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-btn-ph {
  color: #FFFFFF40;
  position: absolute;
  right: 10px;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
}

.connect-wallet-btn {
  margin-bottom: 20px;
}

.did-icon-wrapper {
  background-color: #1B1D29 !important;
  border: 1px solid #242632 !important;
  border-radius: 4px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  width: min-content;
  padding: 10px;
  margin-right: 10px;
}

.did-icon-wrapper-btn {
  background-color: #1B1D29 !important;
  border: 1px solid #242632 !important;
  border-radius: 4px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  width: min-content;
  padding: 5px;
  margin-right: 8px;
}

.did-icon-wrapper-btn svg {
  height: 12px;
  width: 12px;
}

.login-did-btn {
  border: 1px solid #FFFFFF;
}

.login-did-btn span {
  color: #D7DF23;
}

.did-info-label {
  color: #D7DF23;
  font-size: 12px;
  cursor: pointer;
  width: fit-content;
}

.did-info-label:hover {
  border-bottom: 1px solid #D7DF23;
}

.bottom-liner {
  position: absolute;
  bottom: 20px;
  left: 0;
  right: 0;
  color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
}

.bottom-liner span {
  color: #D7DF23;
  cursor: pointer;
}

.bottom-liner span:hover {
  border-bottom: 1px solid #D7DF23;
}

.pmc-right {
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;
  padding: 70px 70px 0px 70px;
}

.pmc-wrapper {
  width: 80%;
}

.pmc-right h1 {
  color: #FFFFFF;
  font-size: 40px;
  line-height: 120%;
}

.pmc-right h1 span {
  color: #D7DF23;
}

.pmc-right .pmc-right-p1 {
  color: #BCBCBC;
  font-size: 14px;
  margin-top: 10px;
  margin-bottom: 24px;
  cursor: pointer;
}

.pmc-right label {
  font-size: 14px;
  color: #FFFFFF;
}

.pmc-right input {
  background: #15161F;
  border: 1px solid #444551;
  color: #FFFFFF;
  padding: 0.75rem !important;
  border-radius: 8px !important;
  width: 100% !important;
  outline: 2px solid transparent !important;
  outline-offset: 2px !important;
  margin-top: 6px;
}

.pmc-right button:active {
  transform: scale(0.99);
}

.password-div-wrapper {
  margin-top: 6px;
  position: relative;
}

.password-div-wrapper input {
  margin-top: 6px;
  margin-top: 0px;
}

.password-div-wrapper span {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  cursor: pointer;
}

.check-box-label {
  color: #BCBCBC;
  font-size: 12px;
}

.sep-line {
  background-color: #444551;
  opacity: 0.5;
}

.sep-line-label {
  color: #FFFFFF50;
  background-color: #1B1D29;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
}

p.text-lime-400 {
  color: #D7DF23;
  display: inline-block;
  margin-top: 12px;
}

@media (max-width: 1024px) {
  .pmc-wrapper {
    width: 100%;
  }

  .pmc-right {
    padding: 70px 40px;
  }
}

@media (max-width: 768px) {}

@media (max-width: 480px) {
  .pmc-right {
    padding: 20px;
  }
}
</style>
